import { createContext, PropsWithChildren, useMemo } from 'react'
import { SwitchTransition, Transition } from 'react-transition-group'
import { useRouter } from 'next/router'

import { stripSlash } from '@/utils/path'

import TransitionMask from './components/transition-mask'
import { useTransition } from './use-transition'

export const TransitionContext = createContext<undefined>(undefined)

const TransitionProvider = ({ children }: PropsWithChildren) => {
  const router = useRouter()
  const contextValue = useMemo(() => undefined, [])
  const { nodeRef, maskRef, handleLeaveTransition, handleEnterTransition, handleEndListener } =
    useTransition()

  return (
    <TransitionContext.Provider value={contextValue}>
      <SwitchTransition mode="out-in">
        <Transition
          nodeRef={nodeRef}
          key={router.asPath}
          onExit={handleLeaveTransition}
          onEnter={handleEnterTransition}
          addEndListener={handleEndListener}
          unmountOnExit
        >
          <main ref={nodeRef} className="static" data-route={stripSlash(router.asPath)}>
            {children}
            <TransitionMask ref={maskRef} />
          </main>
        </Transition>
      </SwitchTransition>
    </TransitionContext.Provider>
  )
}

export default TransitionProvider
